import { Fragment, useEffect, useState, createContext, useContext } from "react";
import { BroadcastChannel } from 'broadcast-channel';
import { 
    CircularProgress, 
    Divider, 
    Chip, 
    Tooltip, 
    Typography ,
    ListItem,
    Stack,
    Checkbox,
    Button,
    ListItemText,
    ListItemIcon, 
    MenuItem,
    Link
} from "@mui/material";
import { tss } from "tss-react";
import { Scrollbars } from "react-custom-scrollbars";
import { useParams, useHistory } from "react-router-dom";
import { getCachedData } from "api/Cache";
import ApiUtils from "api/Utils";
import { config } from "config";
import FoldersActions from "actions/FoldersAction";
import { StorageUtils } from "services/UtilsService";
import EventsEmitter from "events/EventsEmitter";
import AddIcon from '@mui/icons-material/Add';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckboxList from "panels/CheckboxList";
import ProjectItem from "components/ProjectItem";
import Pathfinder from "panels/Pathfinder";
//import CreateProjectPanel from "panels/CreateProjectPanel";
import UploadVersionPanel from "panels/UploadVersionPanel";
import ProcessDataPanel from "panels/ProcessDataPanel";
import MovePanel from "panels/MovePanel";
import ExportPanel from "panels/ExportPanel";
import ProjectSettingsPanel from "panels/ProjectSettingsPanel";
import NewFolderPanel from "panels/NewFolderPanel";
import DeleteItemsPanel, { DeleteItem } from "panels/DeleteItemsPanel";
import RenameItemPanel from "panels/RenameItemPanel";
import AddViewPanel from "panels/AddViewPanel";
import _ from 'utils/@lodash';
import NewVersionIcon from '@mui/icons-material/NewReleases';
import FolderIcon from '@mui/icons-material/Folder';
import TvIcon from '@mui/icons-material/Tv';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { viewableEntitiesType, useVersioning } from "constants/common";
import { defaultViewProgram } from "constants/viewer";
import * as Utils from "services/UtilsService";
import { CircularProgressWithLabel } from "components";
import { getFileIcon } from "actions/GlobalActions";
import { getAccessLevel } from "actions/ViewerTools";
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';

//icons
import { SortByAlpha, FilterList } from "@mui/icons-material";
import { icons } from "constants/viewer";
//styles
import commonStyles, { folderColor, panelBackgroundColor } from "styles/common";
import viewsStyles from "styles/views";

//New projects module
import { useDispatch, useSelector } from 'react-redux';
import CreateProjectPanel from "panels/CreateProjectPanel/index";
import {
	openNewDialog,
    remoteDeleteProject
} from 'store/projects';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { useJumboDialog } from 'themes/jumbo/@jumbo/components/JumboDialog/hooks/useJumboDialog';
import { StyledMenu } from 'themes/jumbo/app/_components/_core';

import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import SubscriptionDialog from 'components/SubscriptionDialog';
import {
    setActiveProjectData,
    resetActiveProjectData
} from "store/auth";
import {AppContext} from "views/Loader";
import { trackEvent } from "components/Tracking";

const useStyles = tss.create(() => ({
    header: {
        flexDirection: "row",
        paddingLeft: 12,
        paddingTop: 12,
        width: "100%",
        alignItems: "center",
        verticalAlign: "top",
    },
    icon: {
        marginLeft: 25,
        cursor: "pointer",
    },
    row: {
        height: 30,
    },
    folderIcon: {
        width: 24,
        height: 34,
        marginRight: 10,
    },
    entitiesListButton: {
        marginTop: 0,
        fontSize: "0.8rem",
        paddingRight: 5,
        maxWidth: 220,
        textAlign: "left",
    },
    fluid: {
        flex: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: "50px",
        " & p ": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
    iconEntity: {
        height: 24,
        width: 24,
        marginRight: 5,
        alignItems: "normal",
    },
    actionButton: {
        marginTop: 3,
        height: 30,
        color: "#28ABE3",
        justifyContent: "flex-start",
    },
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto',
        width: 'unset',
        minWidth: '30px',
        minHeight: '30px',
    },
    sidePanel: {
        alignSelf: 'flex-start'
    }
}));

const getProductId = (catalog: any) => {
    if (catalog && catalog.entity && catalog.entity.workflow_product) {
        return catalog.entity.workflow_product;
    }
    return null;
};

const ProjectsListView = ({dataSource, catalog}: {dataSource: any[]; catalog: any}) => {
    const { 
        selectedItems,
        setSelectedItems,
        allItemsChecked,
        setAllItemsChecked,
        storeCachedData,
        hasFullAccess,
        hasProjectAccess,
        hasActiveSubscription,
        defaultProjects,
        onlyDefaultProjects,
        demoProjectsHidden, 
        setDemoProjectsHidden
    } = useContext<any>(CatalogContext);

    const cachedData = storeCachedData.data;

    const handleCheckboxClick = (e: any) => {
        const { value, checked } = e.target;
    
        if (checked && !defaultProjects.includes(value)) {
          setSelectedItems([...selectedItems, value]);
        } else {
          setSelectedItems(selectedItems.filter((item: any) => item != value));
        }
    };

    const hideDemoProject = (e: any) => {
      const { checked } = e.target;
      setDemoProjectsHidden(checked);
    };

    const selectAllItems = (e: any) => {
      const { checked } = e.target;
      const collection: any[] = [];
  
      checked && dataSource.map((item, index) => {
        !defaultProjects.includes(item.ID) && collection.push(item.ID);
      })
  
      setSelectedItems(collection);
      setAllItemsChecked(checked);
    };

    const deleteSelectedProjects = async (hideDialog: () => void, dispatch: any) => {
        //const cachedData = getCachedData();
        const projectsDispatchs: any[] = [];
        selectedItems.map((itemId: string) => {
            const item = FoldersActions.allEntities.find((entity: any) => entity.ID === itemId);
            if (!item) return;
            if (defaultProjects.includes(item.ID)) return; // if it's a default project we skip it
            const deletedProject = cachedData['projectsRef'].find(
                (projRef: any) => projRef['project_ref'] === itemId
            );
            deletedProject && projectsDispatchs.push(dispatch(remoteDeleteProject({ itemId, projectId: deletedProject['project'] })));
        });
        
        if (projectsDispatchs.length) {
            try {
                const results = await Promise.allSettled(projectsDispatchs);
                // Check if all promises were fulfilled successfully
                const allFulfilled = results.every((result) => result.status === 'fulfilled' && result?.value?.type !== 'projects/delete/rejected');
                FoldersActions.reloadCatalog(() => {
                    hideDialog();
                    if (allFulfilled) {
                        dispatch(addNotification(NotificationModel({ message: 'Selected items have been deleted successfully.', options: { variant: 'success' } })));
                        setSelectedItems([]);
                        setAllItemsChecked(false);
                        EventsEmitter.emit("reloadData", "");
                    } else {
                        dispatch(addNotification(NotificationModel({ message: 'One or more actions failed.', options: { variant: 'error' } })));
                    }
                });
                
                // EventsEmitter.emit("signalr_update", {
                //     type: "entity_update",
                //     action: "reload_all",
                // });
            } catch (error) {
			    dispatch(addNotification(NotificationModel({ message: 'Error deleting selected items.', options: { variant: 'error' } })));
            }
        }
    }

    const ProjectsListHeader = () => {
        const { showDialog, hideDialog } = useJumboDialog();
	    const dispatch = useDispatch();
    
        const handleBulkDelete = (e: any) => {
          showDialog({
            variant: 'confirm',
            title: 'Are you sure?',
            content: 'You won\'t be able to recover these projects later',
            onYes: () => {
                deleteSelectedProjects(hideDialog, dispatch);
            },
            onNo: hideDialog,
          });
        };
        const NewProjectBtn = (props: { onClick? : () => void}) => {
            const { onClick } = props;

            return (
                <Button
                    variant='contained'
                    color="primary"
                    disableElevation
                    size={'small'}
                    id="btn-new-project"
                    onClick={(ev: any) => {
                        ev.stopPropagation();
                        trackEvent("Catalog", "Create Project", "Project Details")
                        !onClick && dispatch(openNewDialog(null));
                        onClick && onClick();
                    }}
                >
                    <AddIcon sx={{width: 25, height: 25, mr: 1}} />
                    New Project
                </Button>
            );
        }
        const DeleteProjectsBtn = (props: { onClick? : () => void}) => {
            const { onClick } = props;

            return (
                <Button
                    variant='contained'
                    color={'error'}
                    disableElevation
                    size='small'
                    onClick={(ev: any) => {
                        ev.stopPropagation();
                        !onClick && handleBulkDelete(ev);
                        onClick && onClick();
                    }}
                >
                    <DeleteIcon sx={{width: 20, height: 20, mr: 1}} />
                    Delete
                </Button>
            );
        }
        return (
          <ListItem id="projects-header" component='div' sx={{backgroundColor: 'rgba(32, 32, 32,.03)', m: '0 25px', width: 'auto', mb: '15px', borderRadius: '12px', pr: '40px', pl: '20px'}}>
            <ListItemText
              sx={{ml: {xs: '-10px', sm: '-10px'}}}
              primary={
                <Stack direction={'row'} spacing={2}>
                    <Div sx={{padding: '0px 0 0 16px', display: 'flex', justifyContent: 'space-between', width: '100%', flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                        <Div sx={{display: 'flex', gap:  {lg: '35px'}, flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                            {!onlyDefaultProjects ? (
                                <label style={{display: 'flex', gap: '3px', alignItems: 'center', cursor: 'pointer'}}>
                                    <Checkbox
                                        color='primary'
                                        checked={allItemsChecked}
                                        onChange={selectAllItems}
                                        sx={{ml: {xs: '-10px', sm: '-10px'}}}
                                    />
                                    <Typography
                                        fontSize={'14px'}
                                        variant={'body1'}
                                        color={'text.secondary'}
                                    >
                                        Select All
                                    </Typography>
                                </label>
                            ) : ""}
                            <label style={{display: 'flex', gap: '3px', alignItems: 'center', cursor: 'pointer'}}>
                                <Checkbox
                                    color='primary'
                                    checked={demoProjectsHidden}
                                    onChange={(e) => {
                                        trackEvent("Catalog", "Demo projects", !demoProjectsHidden ? 'hide' : 'show');
                                        hideDemoProject(e);
                                    }}
                                    sx={{ml: {xs: '-10px', sm: '-10px'}}}
                                />
                                <Typography
                                    fontSize={'14px'}
                                    variant={'body1'}
                                    color={'text.secondary'}
                                >
                                    Hide Demo Projects
                                </Typography>
                            </label>
                        </Div>
                        <Div sx={{display: 'flex', gap: '15px', flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                            { selectedItems.length > 0 && !onlyDefaultProjects ? (
                                <div>
                                    { hasActiveSubscription ? <DeleteProjectsBtn /> : <SubscriptionDialog Component={DeleteProjectsBtn} /> }
                                </div>
                            ): ""}
                            <div>
                                { hasActiveSubscription ? <NewProjectBtn /> : <SubscriptionDialog Component={NewProjectBtn} /> }
                            </div>
                        </Div>
                    </Div>
                </Stack>
              }
            />
          </ListItem>
        );
    };
    return (
        <>
            <ProjectsListHeader />
            <Scrollbars
                autoHeightMax={"100%"}
                style={{ width: "100%", height: "calc(100% - 90px)", overflowX: "hidden"}}
            >
                <div style={{padding: '0px 30px'}}>
                    {
                        dataSource.length ? dataSource.map((item, index) => (
                            <ProjectItem item={item} handleCheckboxClick={handleCheckboxClick} selectedItems={selectedItems} key={index} />
                        )) : (
                            <Typography
                                fontSize={'18px'}
                                variant={'body1'}
                                color={'text.secondary'}
                                sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0'}}
                            >
                                No project found
                            </Typography>
                        )
                    }
                </div>
            </Scrollbars>
        </>
    );
  }

function MainPanel(props: { 
    catalogId: string;
    catalog: any;
    setCatalog: any;
    sort: boolean;
    selectedItems: any[];
    cacheLastUpdate: number;
    entities: any;
    loadEntities: boolean;
    //file_type: string;
}) {
    const { classes: viewsClasses } = viewsStyles();
    const { /*catalogId, catalog,*/ loadEntities, cacheLastUpdate } = props;
    const [filter, setFilter] = useState(Utils.StorageUtils.loadFromSessionStorage("filter") || "all");
    const [reload, setReload] = useState(false);
    //const data: any = getCachedData();

    const { 
        storeCachedData,
        catalog,
        catalogId,
        demoProjectsHidden, 
        defaultProjects
    } = useContext<any>(CatalogContext);
    var projects = storeCachedData.data["projects"];

    const { 
        tourActive,
        stepIndex,
        setRunTour,
        setStepIndex
    } = useContext<any>(AppContext);

    setTimeout(() => {
        if(catalogId !== "0" || !tourActive) return;
        
        setRunTour(true);
        stepIndex !== 1 && setStepIndex(1);
    }, 2000);

    useEffect(() => {
        var updateFilter = (filter: string) => {
            setFilter(filter);
            setReload(true);
        };
        EventsEmitter.on("updateFilter", updateFilter);
        return () => {
            EventsEmitter.removeEventListener("updateFilter", setFilter);
        };
    }, [reload]);
    

    return catalog  ? (
        <div className={viewsClasses.main}>
            { catalogId !== "0" ?  (
                loadEntities ? <CheckboxList {...props} /> : ""
            ) : (
                <ProjectsListView 
                    dataSource={Object.values(projects)
                        .filter((item: any) => (!demoProjectsHidden || !defaultProjects.includes(item.ID)))
                        .filter((item: any) => filter !== 'all' ? item.ID === filter : item.ID !== null)
                        .sort((a:any, b:any) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                    } 
                    catalog={catalog} 
                />
            )}
        </div>
    ) : "";
}

function SidePanel(props: {
    catalogId: string;
    catalog: any;
    selectedItems: any;
    createObject: (evt: any) => void;
    generatedEntities: any;
    access_level: string;
}) {
    const { classes } = useStyles();
    const { catalogId } = props;
    return <div className={classes.sidePanel}>{catalogId === "0" ? <SidePanelProject {...props} /> : <SidePanelFolder {...props} />}</div>;
}

const SidePanelMenuItem = ({ icon, label, onClick, disabled = false, id = "" }: { icon?:React.ReactNode; label: string; onClick: (e: any) => void; disabled?: boolean; id?: string}) => {
    return (
      <MenuItem disabled={disabled} disableRipple sx={{ p: 0, mb: 2 }}>
        <Link underline={'none'} onClick={onClick} {...(id ? { id} : {})}>
          {icon && <ListItemIcon sx={{ color: 'inherit' }}>{icon}</ListItemIcon>}
          <ListItemText sx={{textTransform:'uppercase', fontWeight: 600}}>{label}</ListItemText>
        </Link>
      </MenuItem>
    );
};


function SidePanelFolder(props: {
    catalog: any;
    createObject: (evt: any) => void;
    generatedEntities: any;
    access_level: string;
}) {
    const { classes } = useStyles();
    const { classes: viewsClasses } = viewsStyles();
    const { /*catalog, */createObject, generatedEntities, access_level } = props;
    const { classes: common } = commonStyles();
    const { 
        selectedItems,
        catalog,
        hasFullAccess,
        hasActiveSubscription,
        hasProjectAccess
    } = useContext<any>(CatalogContext);

    const history = useHistory();

    if (!catalog || catalog === null) {
        return "<div>problem</div>";
    }

    const fileType = catalog.file_type;
    const entity: any = catalog["view_type"] ? catalog : FoldersActions.allEntities[catalog.ID];

    const viewCatalog = (e: any) => {
        if (entity && entity.view_type === "container") {
            history.push({
                pathname: "/views/" + catalog.ID,
                state: {
                    from: window.location.pathname.replace("/app", ""),
                },
            });
            history.goForward();
        } else {
            let path;
            if (selectedItems.length === 0) {
                path = "/preview/" + catalog.ID;
            } else {
                path = "/preview/" + selectedItems.join("+");
            }
            history.push({
                pathname: path,
                state: {
                    from: window.location.pathname,
                },
            });
            history.goForward();
        }
    };

    const isViewable = () => {
        let viewable = false;
        const fileType = catalog.file_type;
        const viewType = catalog.view_type;
        const fileState = catalog.state;

        if (fileType && fileType === "IDXORTHO") {
            return viewable;
        }

        if(fileState && fileState !== 'COMPLETE'){
            return viewable;
        }

        if (selectedItems.length === 0) {
            viewable = viewableEntitiesType.includes(viewType) || Object.keys(defaultViewProgram).includes(fileType);
        } else {
            let prevView = true;
            selectedItems.forEach((catalogId: any) => {
                const catalog = FoldersActions.getCatalog(catalogId);
                if (catalog) {
                    const curViewable =
                        viewableEntitiesType.includes(viewType) || Object.keys(defaultViewProgram).includes(fileType);
                    viewable = curViewable && prevView;
                    prevView = viewable;
                }
            });
        }
        return viewable;
    };

    const goToFolder = (id: string) => {
        history.push({
            pathname: "/catalog/" + id,
            state: {
                from: window.location.pathname,
            },
        });
        history.goForward();
    };

    function getIcon(entity: any) {
        const fileTye = getFileIcon(entity);
        var Icon = icons[fileTye];
        if (!Icon) {
            Icon = icons["FILE"];
        }
        return <Icon className={classes.iconEntity} />;
    }

    return (
        <div className={viewsClasses.side}>
            <div className={classes.header}>
                <StyledMenu sx={{ mb: 2 }}>
                    {fileType === "FOLDER" ? (
                        <div className={!hasFullAccess ? common.disabledEvents : ""}>
                            {catalog && catalog.entity && catalog.entity.workflow_product && (
                                <SidePanelMenuItem
                                    label="New Version"
                                    onClick={(e: any) => createObject("uploadVersion")}
                                    icon={<NewVersionIcon fontSize={'small'} /> }
                                    disabled={!hasFullAccess}
                                />
                            )}
                            <SidePanelMenuItem
                                label="New Folder"
                                onClick={() => createObject("newFolder")}
                                icon={<FolderIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess}
                            />
                            <SidePanelMenuItem
                                label="Create View"
                                onClick={() => createObject("newView")}
                                icon={<TvIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess}
                            />
                        </div>
                    ) : (
                        <div className={!hasFullAccess ? common.disabledEvents : ""}>
                            <SidePanelMenuItem
                                label="Rename"
                                onClick={() => createObject("renameItem")}
                                icon={<EditNoteIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess}
                            />
                        </div>
                    )}
                    <span className={!hasFullAccess ? common.disabledEvents : ""}>
                        <SidePanelMenuItem
                            label="Move"
                            onClick={() => createObject("moveData")}
                            icon={<MoveUpIcon fontSize={'small'} /> }
                            disabled={!hasFullAccess || (fileType === "FOLDER" ? (selectedItems.length === 0 ? true : false) : false)}
                        />
                        { !(catalog.ID !== "0" && fileType !== "projects" && fileType !== "FOLDER") && (
                            <SidePanelMenuItem
                                label="Delete"
                                onClick={() => createObject("deleteItem")}
                                icon={<DeleteIcon fontSize={'small'} /> }
                                disabled={!hasFullAccess || (fileType === "FOLDER" ? (selectedItems.length === 0 ? true : false) : false)}
                            />
                        )}
                    </span>
                    { isViewable() && (
                        <div>
                            <SidePanelMenuItem
                                label="View"
                                icon={<ViewInArIcon fontSize={'small'} /> }
                                onClick={viewCatalog}
                            />
                        </div>
                    )}
                    <Divider />
                    <div style={{ margin: 10 }}>
                        {catalog["user"] && (
                            <div>
                                <Typography variant="caption">Created by</Typography>
                                <Typography>{catalog["user"]}</Typography>
                            </div>
                        )}
                        {fileType === "FOLDER" && catalog["capture_date"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Capture Date</Typography>
                                <Typography>{Utils.formatDateWithTime(catalog["capture_date"])}</Typography>
                            </div>
                        )}
                        {fileType !== "FOLDER" && catalog["file_date"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Creation Date</Typography>
                                <Typography>{Utils.formatDateWithTime(catalog["file_date"])}</Typography>
                            </div>
                        )}
                        {catalog["version_active_date"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Activation Date</Typography>
                                <Typography>{Utils.formatDateWithTime(catalog["version_active_date"])}</Typography>
                            </div>
                        )}
                        {catalog["comment"] && (
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="caption">Comment</Typography>
                                <Typography>{catalog["comment"]}</Typography>
                            </div>
                        )}
                    </div>
                </StyledMenu>
            </div>
            {useVersioning && generatedEntities && generatedEntities.length > 0 && (
                <>
                    <Divider />
                    <div style={{ paddingLeft: 20, marginTop: 10, height: "calc(100% - 280px)" }}>
                        <Typography style={{ marginBottom: 5 }}>This version was built using:</Typography>
                        <Scrollbars autoHeightMax={"100%"} style={{ width: "100%", height: "100%", overflowX: "hidden" }}>
                            {generatedEntities.map((entity: any, index: number) => {
                                const workflow = FoldersActions.getWorkflow(entity);
                                return (
                                    <div
                                        style={{ marginTop: 5 }}
                                        onClick={() => {
                                            goToFolder(entity.ID);
                                        }}
                                        key={index}
                                    >
                                        <div className={common.middle} style={{ alignItems: "normal" }}>
                                            {getIcon(entity)}
                                            {workflow === null ? (
                                                <div>
                                                    <div>
                                                        <Button
                                                            color="primary"
                                                            className={classes.entitiesListButton}
                                                            onClick={() => {
                                                                goToFolder(entity.ID);
                                                            }}
                                                        >
                                                            {entity.name}
                                                        </Button>
                                                    </div>
                                                    <Chip label="Not Versioned" size="small" />
                                                </div>
                                            ) : (
                                                <div style={{ marginTop: -5 }}>
                                                    <Button
                                                        color="primary"
                                                        className={classes.entitiesListButton}
                                                        onClick={() => {
                                                            goToFolder(entity.ID);
                                                        }}
                                                    >
                                                        {entity.name}
                                                    </Button>
                                                    <Chip
                                                        label={workflow["version"]}
                                                        size="small"
                                                        style={{ backgroundColor: folderColor }}
                                                    />
                                                    <Tooltip title={workflow["products"].join(" - ")}>
                                                        <Chip
                                                            label={workflow["products"].join(" - ")}
                                                            size="small"
                                                            style={{ marginLeft: 3, marginBottom: 3, maxWidth: 220 }}
                                                        />
                                                    </Tooltip>
                                                    {entity.comment && (
                                                        <div>
                                                            <Typography variant="caption">{entity.comment}</Typography>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </Scrollbars>
                    </div>
                </>
            )}
        </div>
    );
}

function SidePanelProject(props: { catalogId: string; access_level: string; createObject: (evt: any) => void }) {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();
    const { classes: viewsClasses } = viewsStyles();
    var { createObject } = props;
	const dispatch = useDispatch();
    const { 
        selectedItems,
        hasActiveSubscription,
        sweetAlerts
    } = useContext<any>(CatalogContext);

    return (
        <div className={viewsClasses.side}>
            <StyledMenu sx={{ mb: 2 }}>
                <div className={!hasActiveSubscription ? cx(classes.header, common.disabledEvents) : ""}>
                    <SidePanelMenuItem
                        label="New Project"
                        onClick={(ev: any) => {
                            if (!hasActiveSubscription) {
                                sweetAlerts();
                                return;
                            }
                            ev.stopPropagation();
                            dispatch(openNewDialog(null));
                        }}
                        icon={<LibraryAddIcon fontSize={'small'} /> }
                        disabled={!hasActiveSubscription}
                        id="sidebar-new-project"
                    />
                    <SidePanelMenuItem
                        label="Delete Project"
                        onClick={() => createObject("deleteItem")}
                        icon={<DeleteIcon fontSize={'small'} /> }
                        disabled={!hasActiveSubscription || selectedItems.length < 1}
                    />
                </div>
            </StyledMenu>
        </div>
    );
}

function getDependencies(data: any, catalog: any, callback: any) {
    const dependencies: any = [];
    const project = catalog["project"];
    //get all entities of the current project
    const allEntities: any = FoldersActions.allEntities.filter((entity: any) => entity["project"] === project);

    const extractInputs = (updatesList: any) => {
        let pending = updatesList.length;
        updatesList.forEach((object: any) => {
            const inputProperties = Object.getOwnPropertyNames(object).filter((prop: any) => {
                //limit values to guid only which is 32 characters in length
                return prop.includes("input_value_") && object[prop].length === 32;
            });
            inputProperties.forEach((inputId: string) => {
                // get the input value which is the entity id of the object
                const inputValue: string = object[inputId];
                const entry = allEntities.find(
                    (entity: any) =>
                        entity["ID"] === inputValue &&
                        entity["file_folder"] !== catalog["ID"] &&
                        entity["file_type"] &&
                        entity["file_type"] !== "FOLDER"
                );
                if (entry) {
                    const currentFolderId: string = entry["file_folder"];
                    const folderCatalog: any = allEntities.find((entity: any) => entity["ID"] === currentFolderId);
                    if (folderCatalog) {
                        entry["comment"] = folderCatalog["comment"];
                    }
                    // to insure the avoidance of duplication
                    dependencies[inputValue] = entry;
                }
            });
            pending--;
            if (pending === 0) {
                if (dependencies.length > 0) {
                    console.log("dependencies:", dependencies);
                }

                callback(Object.values(dependencies));
            }
        });
    };

    const catalogEntity: any = FoldersActions.getCatalogEntity(catalog);
    if (catalogEntity && catalogEntity["file_type"] === "FOLDER") {
        //get all virtuals of the current project
        const allVirtuals: any = Object.values(data["entities"][project]).filter(
            (entity: any) => entity["virtual"] === "1"
        );
        const files: any = catalog.files || [];
        let updatesList: any = files.filter(
            (object: any) => object["view_type"] !== "container" && object["file_type"]
        );
        const virtuals: any = allVirtuals.filter(
            (object: any) => object["file_folder"] === catalog["ID"] && object["file_type"] === "VIEW"
        );
        updatesList = updatesList.concat(virtuals);
        if (virtuals.length > 0) {
            console.log("virtuals:", virtuals);
        }
        const idsList: any = updatesList.map((entity: any) => {
            return entity["ID"];
        });
        if (Boolean(config.api.filters === "true")) {
            if (idsList.length === 0) {
                callback([]);
                return;
            }
            ApiUtils.getRemoteObjects(idsList, project, (updatesObject: any) => {
                extractInputs(updatesObject);
            });
        } else {
            extractInputs(updatesList);
        }
    } else {
        callback([]);
    }
}

export const CatalogContext = createContext({});

export default function Catalog() {
    const { classes: common } = commonStyles();
    const { classes, cx } = useStyles();
    const { classes: viewsClasses } = viewsStyles();
    var { catalogId:currentCatalogId } = useParams();
    const history = useHistory();
    //const data: any = getCachedData();

    const [loadData, setLoadData] = useState(false);
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState("");
    const [update, setUpdate] = useState(false);
    const [filter, setFilter] = useState(StorageUtils.loadFromSessionStorage("filter") || "all");
    const [catalog, setCatalog] = useState<any>(null);
    const [progress, setProgress] = useState(0);
    const items = FoldersActions.selectedItems;
    const [generatedEntities, setGeneratedEntities] = useState<any>([]);
    const [firstLoad, setFirstLoad] = useState(false);
    const [alphaSort, setAlphaSort] = useState(false);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [allItemsChecked, setAllItemsChecked] = useState(false);
    const [cacheLastUpdate, setCacheLastUpdate] = useState(0);
	const storeCachedData = useSelector((state: any) => state.cache);
	const storeAuthData = useSelector((state: any) => state.auth);
    const [entities, setEntities] = useState<any[]>([]);
    const [loadEntities, setLoadEntities] = useState(false);
    const [catalogId, setCatalogId] = useState(currentCatalogId || '0');
    const { update:cacheUpdateTime, data } = storeCachedData;
    const [projects, setProjects] = useState<any>(null);
    const [type, setType] = useState('projects');
    const dispatch = useDispatch();
    const [hasFullAccess, setHasFullAccess] = useState(false);
    const [hasProjectAccess, setHasProjectAccess] = useState(false);
    const [onlyDefaultProjects, setOnlyDefaultProjects] = useState(false);
    const [demoProjectsHidden, setDemoProjectsHidden] = useState(Number(localStorage.getItem('hideDemoProjects') || 0) > 0);
    const { 
        hasActiveSubscription = false, 
        projectAccessLevel:access_level = "read", 
        activeProject, 
        mainProject, 
        isDefaultProject = false, 
        defaultProjects,
        storage_limit_exceeded,
        processtime_limit_exceeded
    } = storeAuthData;
    
    const Swal = useSwalWrapper();

    useEffect(() => {
        setHasProjectAccess(access_level === (!!activeProject ? 'full' : 'read'))
        setHasFullAccess(hasActiveSubscription && access_level === (!!activeProject ? 'full' : 'read'))
    }, [activeProject, access_level, hasActiveSubscription])

    useEffect(() => {
        localStorage.setItem('hideDemoProjects', demoProjectsHidden ? '1' : '0');
    }, [demoProjectsHidden])

    useEffect(() => {
        const _projects = JSON.parse(JSON.stringify(data.projects));
        if (_.isEqual(projects, _projects)) return;

        setProjects(_projects)
    }, [data.projects, projects])

    useEffect(() => {
        if (!projects) return;
        if (!catalog) return;
        const userProjects = Object.keys(projects).filter((item: string) => !defaultProjects.includes(item))
        setOnlyDefaultProjects(userProjects.length < 1 || (catalog['project'] && defaultProjects.includes(catalog['project'])));
    }, [projects, defaultProjects, catalog])

    useEffect(() => {
        if (currentCatalogId === catalogId) return;

        if (!currentCatalogId || currentCatalogId === "all") {
            setCatalogId('0');
            return;
        }
        setCatalogId(currentCatalogId);
    }, [currentCatalogId, catalogId])

    useEffect(() => {
        //if(cacheUpdateTime ===  cacheLastUpdate) return;
        setCacheLastUpdate(cacheUpdateTime);
        const _catalog = FoldersActions.getCatalog(currentCatalogId);
        
        if (!_catalog) return;
        const type = _catalog.ID === "0" ? "projects" : _catalog.file_type;
        setType(type);
        if (_.isEqual(_catalog, catalog)) return;
        setCatalog(_catalog);
        setLoadEntities(false);
    }, [cacheUpdateTime, catalogId, currentCatalogId, catalog])

    useEffect(() => {
        //if (currentCatalogId && currentCatalogId === catalogId && catalog) return;
        (!currentCatalogId || currentCatalogId === '0') && activeProject && dispatch(resetActiveProjectData());

        currentCatalogId && currentCatalogId !== '0' && (activeProject !== currentCatalogId || (catalog && mainProject !== catalog?.project)) && 
        dispatch(setActiveProjectData({
            activeProject: currentCatalogId,
            ...(catalog?.project ? {mainProject: catalog.project} : {}),
            projectAccessLevel: catalog?.project ? getAccessLevel(catalog?.project) : 'read'
        }));
    }, [catalogId, currentCatalogId, catalog, activeProject])

    useEffect(() => {
        if (!catalog) return;
        if (!cacheLastUpdate) return;
        setLoadEntities(true);
        const _cachedEntities = FoldersActions.listFolderItems(catalog, type);
        const cachedEntities = _cachedEntities?.filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.ID)) 
        setEntities(cachedEntities);
        setFirstLoad(true);
        //setReload(true);
    }, [cacheLastUpdate, catalog, type])

    

    //const entities = FoldersActions.listFolderItems(catalog, type);

    useEffect(() => {
        if (catalogId === currentCatalogId) return;
        setAllItemsChecked(false);
        setSelectedItems([])
    }, [catalogId, currentCatalogId]);

    useEffect(() => {
        if (_.isEqual(FoldersActions.selectedItems, selectedItems)) return;
        FoldersActions.selectedItems =  [...selectedItems];
        setUpdate((prevUpdate) => !prevUpdate);
    }, [selectedItems, FoldersActions.selectedItems]);

    useEffect(() => {
        if (data.loaded && !reload) {
            if (FoldersActions.catalog === null) {
                var curCatalog = FoldersActions.getCatalog(catalogId);
                //console.log("****1.Catalog.curCatalog:", curCatalog);
                setCatalog(curCatalog);
                FoldersActions.catalog = curCatalog;
                setLoadData(data.loaded);
            }
        }
        // Remove reload to fix add object popup 2025-07-15
        if (data.loaded /*|| reload*/) {
            //console.log("catalog buildFolderTree...");
            FoldersActions.assigned = false;
            FoldersActions.buildFolderTree(filter, catalogId, () => {
                var curCatalog = FoldersActions.getCatalog(catalogId);
                //console.log("****2.Catalog.curCatalog:", curCatalog);
                setCatalog(curCatalog);
                //FoldersActions.catalog = curCatalog;
                setLoadData(true);
                setReload(false);
            });
        }
    }, [data, catalogId, filter, reload]);

    useEffect(() => {
        const updateFilter = (filter: string) => {
            setFilter(filter);
            setReload(true);
        };

        const reload = (event: any) => {
            if (
                data.loaded &&
                (catalogId === event["id"] || catalogId === event["folder"] || event["action"] === "reload_all")
            ) {
                console.log("Catalog.signalr.updateEvent:", event);
                setReload(true);
            }
        };

        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };

        const handleListBoxSelectedChange = (selectedItems: string[]) => {
            FoldersActions.selectedItems = selectedItems;
            setUpdate((prevUpdate) => !prevUpdate);
        };

        const reloadCatalog = () => {
            setReload(true);
        };

        EventsEmitter.on("reloadCatalog", reloadCatalog);
        EventsEmitter.on("updateFilter", updateFilter);
        //EventsEmitter.on("signalr_update", reload);
        EventsEmitter.on("updateCatalogList", handleListBoxSelectedChange);
        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("reloadCatalog", reloadCatalog);
            EventsEmitter.removeEventListener("updateFilter", updateFilter);
            // EventsEmitter.removeEventListener("signalr_update", reload);
            EventsEmitter.removeEventListener("updateCatalogList", handleListBoxSelectedChange);
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };
    }, [data, catalogId]);

    useEffect(() => {
        return () => {
            FoldersActions.catalog = null;
            FoldersActions.selectedItems = [];
        };
    }, []);

    useEffect(() => {
        if(currentCatalogId === catalogId) return;

        const catalog = FoldersActions.getCatalog(catalogId);
        setCatalog(catalog);
        return () => {
            setFirstLoad(false);
        };
    }, [catalogId, currentCatalogId]);

    //Get all entities used to generate results that are not part of this folder, to show on <SidePanelFolder>
    useEffect(() => {
        //console.log("firstLoad:", firstLoad, "|catalog:", catalog);
        if (data.loaded && catalog && catalog.ID && !firstLoad) {
            getDependencies(data, catalog, (generatedEntities: any) => {
                if (Array.isArray(generatedEntities)) {
                    generatedEntities = Utils.cleanArray(generatedEntities);
                    setGeneratedEntities(generatedEntities);
                }
                setFirstLoad(true);
            });
        }
    }, [data, catalog, firstLoad]);

    if (!data.loaded || !loadData || !catalog || !loadEntities) {
        return <CircularProgressWithLabel className={classes.CircularProgress} value={progress || 0} />;
    }

    const sweetAlerts = () => {
        Swal.fire({
        title: 'Your account has limited access!',
        text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
        imageWidth: 450,
        imageHeight: 200,
        confirmButtonText: "Upgrade my plan",
        showCloseButton: true,
        }).then((result) => {
            result.isConfirmed && history.push("/profile");
        });
    };

    const createObject = (name: any) => {
        let state = isDefaultProject || !hasFullAccess;
        if( ['newFolder', 'newView'].includes(name)) {
            state = state || (processtime_limit_exceeded || storage_limit_exceeded);
            console.log("State : " + state)
            console.log('processtime_limit_exceeded : ' + processtime_limit_exceeded)
            console.log('storage_limit_exceeded : ' + storage_limit_exceeded)
        }
        if (state) {
            /*!hasFullAccess && */sweetAlerts();
            return;
        }
        setOpen(name);
    };

    const setProject = (projectId: string) => {
        var index = Object.keys(projects).findIndex((project: any) => project === projectId);
        if (index !== -1) {
            setUpdate((prevUpdate: boolean) => !prevUpdate);
            history.push("/catalog/" + projectId);
        }
    };
    const sortAlphabetic = () => {
        setAlphaSort((prevSort: boolean) => !prevSort);
    };

    const handleClose = () => {
        setOpen("");
        FoldersActions.assigned = false;
        FoldersActions.selectedItems = [];
    };
    const CatalogContextValue = {
        selectedItems,
        setSelectedItems,
        allItemsChecked,
        setAllItemsChecked,
        cacheLastUpdate,
        storeCachedData,
        catalogId,
        catalog,
        setCatalog,
        entities,
        setEntities,
        setReload,
        hasFullAccess,
        hasProjectAccess,
        hasActiveSubscription,
        isDefaultProject,
        defaultProjects,
        onlyDefaultProjects,
        sweetAlerts,
        demoProjectsHidden, 
        setDemoProjectsHidden,
        storage_limit_exceeded,
        processtime_limit_exceeded
    }

    return catalog && loadEntities ? (
        <CatalogContext.Provider value={CatalogContextValue}>
            <div className={viewsClasses.root} style={{ filter: update ? "none" : "none" }}>
                <div className={cx(common.middle, viewsClasses.topHeader)}>
                    <div style={{paddingLeft: catalogId === "0" ? '10px' : '0px'}}><Pathfinder /></div>
                    <div className={common.right}>
                        <FilterList style={{ display: "none" }} className={cx(classes.icon, common.disabledEvents)} />
                        <SortByAlpha
                            style={{ display: "none" }}
                            className={cx(classes.icon, common.disabledEvents)}
                            onClick={sortAlphabetic}
                        />
                    </div>
                </div>
                <Div className={viewsClasses.content} sx={{flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                    <MainPanel 
                        catalogId={catalogId} 
                        catalog={catalog} 
                        setCatalog={setCatalog} 
                        entities={entities}
                        loadEntities={loadEntities}
                        sort={alphaSort} 
                        selectedItems={FoldersActions.selectedItems}
                        cacheLastUpdate={cacheLastUpdate}
                        //file_type={catalogId === "0" ? "projects" : catalog.file_type}
                    />
                    { catalogId !== "0" && (
                        <SidePanel
                            catalogId={catalogId}
                            catalog={catalog}
                            createObject={createObject}
                            selectedItems={FoldersActions.selectedItems}
                            generatedEntities={generatedEntities}
                            access_level={access_level}
                        />
                    )}
                </Div>
                {catalogId === "0" ? (
                    <Fragment>
                        {/*<CreateProjectPanel
                            open={open === "createProject"}
                            handleClose={handleClose}
                            setProject={setProject}
                        />*/}
                        <CreateProjectPanel />
                        <DeleteItemsPanel open={open === "deleteItem"} handleClose={handleClose} />
                    </Fragment>
                ) : (
                    <Fragment>
                        {open !== "" ? (
                            <div>
                                <UploadVersionPanel
                                    open={open === "uploadVersion"}
                                    handleClose={handleClose}
                                    product={getProductId(catalog)}
                                    project={catalog["project"]}
                                />
                                <ProcessDataPanel
                                    open={open === "processData"}
                                    handleClose={handleClose}
                                    catalogId={catalogId}
                                />
                                <NewFolderPanel open={open === "newFolder"} handleClose={handleClose} catalog={catalog} />
                                <RenameItemPanel open={open === "renameItem"} handleClose={handleClose} catalog={catalog} />
                                <DeleteItemsPanel open={open === "deleteItem"} handleClose={handleClose} />
                                {open === "newView" ? (
                                    <AddViewPanel
                                        handleClose={handleClose}
                                        folderId={catalog["ID"]}
                                        projectId={catalog["project"]}
                                    />
                                ) : (
                                    ""
                                )}
                                <MovePanel
                                    open={open === "moveData"}
                                    handleClose={handleClose}
                                    catalog={catalog}
                                    items={catalog?.file_type === "FOLDER" ? items : [catalogId]}
                                />
                                <ExportPanel open={open === "exportData"} handleClose={handleClose} catalogId={catalogId} />
                                <ProjectSettingsPanel
                                    open={open === "projectSettings"}
                                    handleClose={handleClose}
                                    catalogId={catalogId}
                                />
                            </div>
                        ) : (
                            ""
                        )}
                    </Fragment>
                )}
            </div>
        </CatalogContext.Provider>
    ) : "";
}
